import * as types from '../const/action.types';
import { get, put } from '../api/_basic';

export function loadDashboard() {
    return async (dispatch) => {
        dispatch(dashboardHasErrored(false, ''));
        dispatch(dashboardIsLoading(true));
        dispatch(loadIndicators());
        dispatch(loadDashboardSuccess([]));
        try {
            const response = await get(`${process.env.REACT_APP_API_DASHBOARD}`);
            dispatch(dashboardIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const widgets = response && response.length > 0 ? response[0].widgets : undefined;
            dispatch(dashboardHasErrored(false, ''));
            dispatch(loadDashboardSuccess(response));
            if (widgets) {
                dispatch(loadDashboardCurrentTab(widgets));
            }
        } catch (error) {
            console.error(error);
            dispatch(loadDashboardSuccess([]));
        } finally {
            dispatch(dashboardIsLoading(false));
        }
    };
}

export function loadDashboardCurrentTab(widgets, indicators, currenttabs) {
    return async (dispatch) => {
        dispatch(dashboardIsLoading(true));
        dispatch(dashboardTab([]));
        try {
            const response = await Promise.all(
                widgets.map(async (tab, index) => {
                    if (
                        indicators === undefined ||
                        indicators.length === 0 ||
                        indicators.indexOf(parseInt(tab.origen, 10)) >= 0
                    ) {
                        const periodo =
                            tab.metadatos && tab.metadatos.periodo ? tab.metadatos.periodo : '';
                        const aux = await get(
                            `${process.env.REACT_APP_API_INDICATORS}/${tab.origen}${
                                periodo ? `?periodo=${periodo} ` : ''
                            }`,
                        );
                        aux.nombre = tab.nombre;
                        return aux;
                    } else {
                        return currenttabs[index];
                    }
                }),
            );
            dispatch(dashboardIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            dispatch(dashboardTab(response));
        } catch (error) {
            console.error(error);
            dispatch(dashboardTab([]));
        } finally {
            dispatch(dashboardIsLoading(false));
        }
    };
}

export function updateDashboard(dashboard) {
    return async (dispatch) => {
        dispatch(dashboardIsSaving(true));
        try {
            const response = await put(`${process.env.REACT_APP_API_DASHBOARD}`, dashboard);
            dispatch(dashboardIsSaving(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            return true;
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
}

export function loadIndicators() {
    return async function(dispatch) {
        dispatch(indicatorsHasErrored(false, ''));
        try {
            const response = await get(`${process.env.REACT_APP_API_INDICATORS}`);
            if (response.error !== undefined) {
                throw Error(response);
            }
            const item = response;
            dispatch(loadIndicatorsSuccess(item));
        } catch (error) {
            dispatch(indicatorsHasErrored(error.type ? error.type : true, error.message));
        }
    };
}

export function loadIndicatorsSuccess(data) {
    return {
        type: types.LOAD_INDICATORS_SUCCESS,
        data,
    };
}

export function loadDashboardSuccess(data) {
    return {
        type: types.DASHBOARDS_SUCCESS,
        data,
    };
}

export function dashboardHasErrored(bool, message) {
    return {
        type: types.DASHBOARD_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function indicatorsHasErrored(bool, message) {
    return {
        type: types.INDICATORS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function dashboardIsLoading(bool) {
    return {
        type: types.DASHBOARDS_IS_LOADING,
        isLoading: bool,
    };
}

export function dashboardIsSaving(bool) {
    return {
        type: types.DASHBOARDS_IS_SAVING,
        isLoading: bool,
    };
}

export function dashboardTab(charts) {
    return {
        type: types.DASHBOARDS_CURRENT_TAB,
        data: charts,
    };
}



// WEBPACK FOOTER //
// ./src/actions/dashboard.actions.js